import { createStringHashCode } from './CreateStringHashCode';

export const setHashedEmailInStorage = async (email: string) => {
	if (null != email) {
		const hashedEmail = await createStringHashCode(email);
		sessionStorage.setItem('HASH_EMAIL', JSON.stringify({ email: email, hash: hashedEmail }));
	}
};
